"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnFilter = void 0;

var _react = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _antd = require("antd");

var _filters = require("../../../constants/filters");

var _columnFilter = require("../../../constants/columnFilter");

var _Loader = _interopRequireDefault(require("../../Loader"));

var _treeChanges2 = _interopRequireDefault(require("tree-changes"));

var _component = require("../../../constants/component");

var _FilterFieldProvider = require("../FilterFieldProvider/FilterFieldProvider");

var _dateTypes = require("../../../constants/dateTypes");

var _defineProperty2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Option = _antd.Select.Option;
var comboBoxStyle = {
  maxWidth: '80%',
  minWidth: '143px'
};
var optionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

var ColumnFilter =
/*#__PURE__*/
function (_Component) {
  _inherits(ColumnFilter, _Component);

  function ColumnFilter(props) {
    var _this;

    _classCallCheck(this, ColumnFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ColumnFilter).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getDisplayOptions", function () {
      var searchInput = _this.state.searchInput;
      var _this$props = _this.props,
          options = _this$props.options,
          sortOptions = _this$props.sortOptions;

      var sortFunction = function sortFunction(a, b) {
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        if (b.name.toLowerCase() > a.name.toLowerCase()) return -1;
        return 0;
      };

      if (typeof sortOptions === 'function') {
        sortFunction = sortOptions;
      }

      var showSearched = function showSearched(option) {
        return option.name.toUpperCase().indexOf(searchInput.toUpperCase()) !== -1;
      };

      if (sortOptions) {
        return options.sort(sortFunction).filter(showSearched);
      }

      return options.filter(showSearched);
    });

    _defineProperty(_assertThisInitialized(_this), "createTriggerForTableScroll", function () {
      var tableContent = document.querySelector('div.ant-tabs-content.ant-tabs-content-animated > div.ant-tabs-tabpane.ant-tabs-tabpane-active > div > div > div.ant-table-wrapper > div.ant-spin-nested-loading > div > div > div > div');

      if (tableContent) {
        tableContent.addEventListener('scroll', function triggerFunction(event) {
          var selectorComponent = document.querySelectorAll('#antTableSelector');

          _lodash["default"].forEach(selectorComponent, function (paragraph) {
            paragraph.blur();
          }, false);

          tableContent.removeEventListener('scroll', triggerFunction);
          tableContent = null;
        }, false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearch", function (value) {
      _this.setState({
        searchInput: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      if (_this.props.mode === _columnFilter.FILTER_MODE_TYPE.DATE) {
        value = value ? value.format(_this.props.dateValueFormat) : null;

        _this.onDatePickerOpenChange(false);
      }

      _this.setState({
        value: value
      });

      if (_this._debounceApplyFilter) _this._debounceApplyFilter.cancel();
      _this._debounceApplyFilter = _lodash["default"].debounce(_this.applyFilter, 350);

      _this._debounceApplyFilter();
    });

    _defineProperty(_assertThisInitialized(_this), "createOptionLabel", function (option) {
      var translate = _this.props.translate;

      if (_this.props.showQty && option.qty) {
        return translate(option.name) + ' (' + option.qty + ') ';
      } else {
        return translate(option.name);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "applyFilter", function () {
      var _this$props2 = _this.props,
          applyFilter = _this$props2.applyFilter,
          filterType = _this$props2.filterType,
          fieldName = _this$props2.fieldName;
      var value = _this.state.value; // if it is single value - push it into array to handle it as list in backend

      var valueArray = [];

      if (Array.isArray(value)) {
        valueArray = value;
      } else if (_columnFilter.FILTER_COLUMN_LIST_TYPE.includes(fieldName)) {
        valueArray.push(value);
      } else {
        valueArray = value;
      }

      var filterEnabled = ['productStatusCumulative', 'emailSettings', 'userPermissions', 'productStatusFull'].includes(filterType);
      applyFilter(filterType, _defineProperty({}, fieldName, valueArray), filterEnabled);

      _this.setState({
        searchInput: ""
      });

      if (_this.props.onChange) {
        _this.props.onChange(value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isAllOptionsSelected", function () {
      var options = _this.props.options;
      var value = _this.state.value;
      var values = value || [];
      return !(values.length === 0 || values.length < options.length);
    });

    _defineProperty(_assertThisInitialized(_this), "selectAll", function () {
      var options = _this.props.options;
      var selected = !_this.isAllOptionsSelected();
      var selectedValue = [];

      if (selected) {
        selectedValue = options.map(function (v) {
          return v.id.toString();
        });
      }

      _this.handleChange(selectedValue);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      _this.props.multiSortField.selected = true;
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.props.multiSortField.selected = false;
    });

    _defineProperty(_assertThisInitialized(_this), "onDatePickerOpenChange", function (status) {
      _this.setState({
        openDatePicker: status
      });
    });

    _this.state = {
      searchInput: "",
      value: props.value,
      openDatePicker: false
    };
    return _this;
  }

  _createClass(ColumnFilter, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _treeChanges = (0, _treeChanges2["default"])(this.props, prevProps),
          changed = _treeChanges.changed;

      if (changed('value')) {
        this.setState({
          value: this.props.value
        });
      }

      this.createTriggerForTableScroll();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          defaultFirstOption = _this$props3.defaultFirstOption,
          title = _this$props3.title,
          translate = _this$props3.translate,
          mode = _this$props3.mode,
          allowClear = _this$props3.allowClear,
          showArrow = _this$props3.showArrow,
          isLoading = _this$props3.isLoading,
          selectAll = _this$props3.selectAll,
          showSearch = _this$props3.showSearch,
          style = _this$props3.style,
          placeholder = _this$props3.placeholder;
      var value = this.state.value;
      var displayOptions = this.getDisplayOptions();
      var values = value || [];
      var selectedAll = !(values.length === 0 || values.length < displayOptions.length);
      return _react["default"].createElement(_react["default"].Fragment, null, mode === _columnFilter.FILTER_MODE_TYPE.DATE ? _react["default"].createElement(_antd.DatePicker, {
        onChange: this.handleChange,
        onOpenChange: this.openDatePicker,
        format: this.props.dateFormat,
        placeholder: translate(placeholder)
      }) : _react["default"].createElement(_antd.Select, {
        mode: mode,
        dropdownMatchSelectWidth: false,
        defaultFirstOption: defaultFirstOption,
        showSearch: showSearch,
        allowClear: allowClear,
        showArrow: showArrow,
        filterOption: false,
        value: values,
        notFoundContent: isLoading ? _react["default"].createElement(_Loader["default"], {
          size: "small"
        }) : null,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onFocus: this.createTriggerForTableScroll,
        style: style,
        placeholder: translate(title),
        onSearch: this.handleSearch,
        onChange: this.handleChange,
        id: "antTableSelector"
      }, _lodash["default"].map(displayOptions, function (option) {
        return _react["default"].createElement(Option, {
          key: option.name + option.id,
          value: option.id.toString(),
          onMouseEnter: _this2.onMouseEnter,
          onMouseLeave: _this2.onMouseLeave
        }, _this2.createOptionLabel(option));
      })), selectAll && _react["default"].createElement(_antd.Tooltip, {
        title: "Select All",
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      }, _react["default"].createElement(_antd.Checkbox, {
        style: {
          verticalAlign: 'middle',
          marginLeft: '7px'
        },
        onChange: this.selectAll,
        disabled: displayOptions.length === 0,
        checked: selectedAll
      })));
    }
  }]);

  return ColumnFilter;
}(_react.Component);

exports.ColumnFilter = ColumnFilter;

_defineProperty(ColumnFilter, "propTypes", (_defineProperty2 = {
  filterType: PropTypes.oneOf(_lodash["default"].values(_filters.FILTER_TYPE)).isRequired,
  fieldName: PropTypes.oneOf(_lodash["default"].values(_filters.FILTER_FIELD)).isRequired,
  options: PropTypes.arrayOf(optionShape),
  defaultOptions: PropTypes.arrayOf(optionShape),
  sortOptions: PropTypes.bool
}, _defineProperty(_defineProperty2, _component.PROPS.OPTIONS_SOURCE, _FilterFieldProvider.optionsSourceShape), _defineProperty(_defineProperty2, "title", PropTypes.string), _defineProperty(_defineProperty2, "primaryFilter", PropTypes.bool), _defineProperty(_defineProperty2, "mode", PropTypes.string.isRequired), _defineProperty(_defineProperty2, "allowClear", PropTypes.bool), _defineProperty(_defineProperty2, "defaultFirstOption", PropTypes.bool), _defineProperty(_defineProperty2, "showArrow", PropTypes.bool), _defineProperty(_defineProperty2, "showQty", PropTypes.bool), _defineProperty(_defineProperty2, "applyFilter", PropTypes.func.isRequired), _defineProperty(_defineProperty2, "dateFormat", PropTypes.string), _defineProperty(_defineProperty2, "dateValueFormat", PropTypes.string), _defineProperty(_defineProperty2, "onChange", PropTypes.func), _defineProperty(_defineProperty2, "style", PropTypes.object), _defineProperty2));

_defineProperty(ColumnFilter, "defaultProps", {
  options: [],
  mode: _columnFilter.FILTER_MODE_TYPE.DEFAULT,
  primaryFilter: false,
  allowClear: true,
  defaultFirstOption: false,
  showArrow: false,
  sortOptions: true,
  dateFormat: _dateTypes.DATE_TYPE,
  dateValueFormat: _dateTypes.DATE_TIME_TYPE,
  style: comboBoxStyle,
  showQty: true
});